/**
 * Gérer l'intéractivité du "lien" select account dans le menu (si connecté).
 *
 * @export
 * @class SelectAccount
 */
export default class SelectAccount {
    selectAccountAnchor;
    selectAccountForm;
    menu;
    isOuvert = false;
    /**
     * Créer une instance de SelectAccount.
     *
     * @param {HTMLAnchorElement} selectAccountAnchor Le lien "Select active account" (#select-account).
     * @param {HTMLFormElement} selectAccountForm Le formulaire "Select active account".
     * @memberof SelectAccount
     */
    constructor(selectAccountAnchor, selectAccountForm, menu) {
        this.selectAccountAnchor = selectAccountAnchor;
        this.selectAccountForm = selectAccountForm;
        this.menu = menu;
        this.ajouterListeners();
        if (selectAccountAnchor.hasAttribute('data-afficher-modal')) {
            if (selectAccountAnchor.getAttribute('data-afficher-modal') == 'afficher') {
                this.afficher();
            }
        }
    }
    /**
     * Ajouter les listeners.
     *
     * @private
     * @memberof SelectAccount
     */
    ajouterListeners() {
        this.selectAccountAnchor.addEventListener("click", () => { this.toggle(); });
        window.addEventListener("click", (ev) => { this.gererClickWindow(ev); });
    }
    /**
     * Ouvrir — ou fermer — le formulaire de sélection de compte.
     *
     * @private
     * @memberof SelectAccount
     */
    toggle() {
        if (this.isOuvert) {
            this.selectAccountForm.style.display = 'none';
        }
        else {
            this.selectAccountForm.style.display = 'flex';
            this.menu.toggle();
        }
        this.isOuvert = !this.isOuvert;
    }
    /**
     * Gérer un click sur la fenêtre.
     *
     * @private
     * @memberof SelectAccount
     * @param ev MouseEvent
     */
    gererClickWindow(ev) {
        if (!this.isOuvert) {
            return;
        }
        if (!(ev.target instanceof Node)) {
            return;
        }
        if (this.selectAccountAnchor.contains(ev.target) ||
            this.selectAccountForm.contains(ev.target)) {
            return;
        }
        this.selectAccountForm.style.display = 'none';
        this.isOuvert = false;
    }
    /**
     * Afficher le modal de choix de comptes. Tout simplement.
     *
     * @private
     * @memberof SelectAccount
     */
    afficher() {
        this.selectAccountForm.style.display = 'flex';
        this.isOuvert = true;
    }
}
